module.exports = __webpack_public_path__ + "static/media/personal-info.85d12306.svg";